<script lang="ts">
import { h, defineComponent, type VNode } from 'vue';

import { formatSpaceSizeLabel } from '@/bundles/MeasurementUnits/helpers';
import { getLandSizeFormatted } from '@/bundles/MeasurementUnits/helpers/format/getLandSizeFormatted';
import store from '@/store/store';
import { conversionToSFFactors } from '@/utils/unitOfMeasureFilters';
import { SpaceMeasurementUnits } from '@/bundles/MeasurementUnits/types';
import { formatRawNumber } from '@/utils/filters';
import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';

export default defineComponent({
  name: 'LandSizeLabel',

  props: {
    value: {
      type: [String, Number],
      default: null
    },
    showSquareFeet: Boolean,
    cutZero: Boolean
  },

  render (): VNode {
    const value = this.$props.value;
    const className = `${this.$attrs.class || ''}`.trim();

    if (!isValuePresent(value)) {
      return h('span', { class: `${className} na`.trim() }, 'N/A');
    }

    const defaultLandSizeUnit = store.state.MeasurementUnits.landSize;
    const selectedLandSizeUnit = store.state.accountSettings?.properties?.land_size_type?.value;

    const label = getLandSizeFormatted(value, this.$props.cutZero);

    if (selectedLandSizeUnit === SpaceMeasurementUnits.sf && formatRawNumber(value)! > 700000) { // more than 700,000 SF
      return h('span', {
        ...this.$attrs,
        class: `${className} white-space--normal`.trim(),
      }, `${formatSpaceSizeLabel(value, { // Show both units (Acres first)
        from: defaultLandSizeUnit,
        to: SpaceMeasurementUnits.acres
      }, { cutZero: this.$props.cutZero })} (${label})`);
    }

    if (!this.$props.showSquareFeet || selectedLandSizeUnit === SpaceMeasurementUnits.sf) {
      return h('span', { ...this.$attrs, class: className || undefined }, label);
    }

    if (formatRawNumber(value)! < conversionToSFFactors[SpaceMeasurementUnits.acres] * 22) { // less than 1 Acre
      return h('span', { ...this.$attrs, class: className || undefined }, `${label} (${formatSpaceSizeLabel(value, { // Show both units
        from: defaultLandSizeUnit,
        to: defaultLandSizeUnit
      }, { cutZero: this.$props.cutZero })})`);
    }

    return h('span', label);
  }
});
</script>
